export default {"src":"/_next/static/media/cross.74b9021d.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};